export default __webpack_public_path__ + "static/media/no-images.3c1754d4.jpg";